var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.term)?_c('span',[(_vm.term.color)?_c('div',{staticClass:"color-preview",style:({background: _vm.term.color})}):_vm._e(),_vm._v(" "+_vm._s(_vm.term.name)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }